import { PayloadAction } from '@reduxjs/toolkit';

import { IState } from '../types/state';

const setFavoriteCatalogs = (state: IState, action: PayloadAction<string>) => {
  state.fuelCards.activeFuelCard = action.payload;
};

export default setFavoriteCatalogs;
